const courseStatuses = [
  { name: "Programmed", value: "PROGRAMMED" },
  { name: "Current", value: "CURRENT" },
  { name: "Completed", value: "COMPLETED" },
];

export default courseStatuses;
